import { render, staticRenderFns } from "./ViewHolderPc.vue?vue&type=template&id=0b88c720&scoped=true"
import script from "./ViewHolderPc.vue?vue&type=script&lang=ts"
export * from "./ViewHolderPc.vue?vue&type=script&lang=ts"
import style0 from "./ViewHolderPc.vue?vue&type=style&index=0&id=0b88c720&prod&lang=less&scoped=true"
import style1 from "./ViewHolderPc.vue?vue&type=style&index=1&id=0b88c720&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88c720",
  null
  
)

export default component.exports